import { AppUserValue, expandAppUserView } from 'lib/actions/apps/app-users'
import { AppUsageControlsServiceClient } from 'pbts/c1/api/app/v1/app_usage.client'
import { AppUserRef, AppUserView } from 'pbts/c1/api/app/v1/app_user'
import { createPagedListApi } from 'redux_toolkit/lib/createPagedListApi'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

const transformAppUserValueArrayResponse = (resp): Array<AppUserValue> => {
    return resp.list.map((v: AppUserView): AppUserValue => {
        return expandAppUserView(v, resp.expanded)
    })
}

export const countInactiveUsersPastThirtyDays = createUnaryApi(AppUsageControlsServiceClient, 'countInactiveUsersPastThirtyDays')

export const searchInactiveUsersPastThirtyDays = createUnaryApi(AppUsageControlsServiceClient, 'searchInactiveUsersPastThirtyDaysForAllApps')

export const searchInactiveUsers = createPagedListApi(
    AppUsageControlsServiceClient,
    'searchInactiveUsers',
    transformAppUserValueArrayResponse,
    AppUserRef.typeName,
)

export const countInactiveUsersForApp = createUnaryApi(AppUsageControlsServiceClient, 'countInactiveUsersForApp')
